// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__2vbU0","content":"styles_content__3Hc0q","contentContainer":"styles_contentContainer__1ldqN","jobDescription":"styles_jobDescription__3fOyy"};